// NEW: UI_REVAMP
import { create } from 'zustand';

export const useBet1Store = create((set) => ({
	swer3Selection: [[], [], []],
	ez2Selection: [[], [], [], []],

	setSwer3Selection: (selection) => set({ swer3Selection: selection }),
	setEz2Selection: (selection) => set({ ez2Selection: selection }),

	updateSwer3Selection: (colIdx, digit) =>
		set((state) => {
			const newSelection = [...state.swer3Selection];
			const currentCols = [...newSelection[colIdx]];
			if (currentCols.includes(digit)) {
				newSelection[colIdx] = currentCols.filter((d) => d !== digit);
			} else {
				newSelection[colIdx] = [...currentCols, digit];
			}
			return { swer3Selection: newSelection };
		}),

	updateEz2Selection: (colIdx, digit) =>
		set((state) => {
			const newSelection = [...state.ez2Selection];
			const currentCols = [...newSelection[colIdx]];
			if (currentCols.includes(digit)) {
				newSelection[colIdx] = currentCols.filter((d) => d !== digit);
			} else {
				newSelection[colIdx] = [...currentCols, digit];
			}
			return { ez2Selection: newSelection };
		}),

	clearSelections: () =>
		set({
			swer3Selection: [[], [], []],
			ez2Selection: [[], [], [], []],
		}),
}));
